import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import { BuildCategories } from '../utils'
import { loadCategories } from '../utils/Network'
import { makeDarkSelectStyles, withMenuPortal } from './selectStyles';

export default function SelectCategory({ callback, value, width, border, placeholder, usersFilter = false }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = useMemo(
        () =>
            withMenuPortal(
                makeDarkSelectStyles({
                    width: width || '220px',
                    border,
                })
            ),
        [width, border]
    );

    
    useEffect(() => {
        loadCategories().then(categories => {
            if (categories.detail) return;

            if (categories) {
                var built_categories = BuildCategories(categories);
                var temp_options = [];

                built_categories.forEach((item) => {
                    temp_options.push({
                        label: item.title,
                        value: item.id
                    });

                    item.childs.map((child, index) => {
                        temp_options.push({
                            label:
                                "   » " + child.title
                            , value: child.id
                        })
                    })

                   

                })
                setSelectOptions(temp_options);
            }

        })
    }, [])

    const handleSelect = (e) => {

        callback(e && e.value, "category")
        

    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Parent"}
                    isClearable={true}
                    value={SelectOptions && SelectOptions.filter(obj => obj.value === value)}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>
            
        </>
    )
}
